"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConceptMaterialType = void 0;
const constants_1 = require("../constants");
class ConceptMaterialType {
    constructor(title, subject, category) {
        this.supportedGameplays = [];
        this.title = title;
        this.subject = subject;
        this.materialCategory = category;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_CONCEPT_MATERIAL;
    }
}
exports.ConceptMaterialType = ConceptMaterialType;
